import { IconMapper } from "../../../lib/generique";
import RenderItemAgenda from "../Commun/RenderItemAgenda";
import dayjs from 'dayjs'
import { AgendaWebProps } from "../CalendrierUniversel.types";
import { useMemo } from "react";
import { DateLocalizer, Navigate, NavigateAction } from 'react-big-calendar'
import { Text, View } from "react-native";
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";
import CalendrierDetailStyle from "../../CalendrierDetail/CalendrierDetail.styles";
import { FormattedEventType } from "../../../api/DemandeAbsence/types";

const AgendaWeb = ({date, events, onSelectEvent}: AgendaWebProps) => {
  const debutMois = useMemo(() => dayjs(date).startOf('month'), [date])
  const finMois = useMemo(() => dayjs(date).endOf('month'), [date])
  const eventsByDates = useMemo(() =>  {
    const dates: {[key: string]: FormattedEventType[]} = {};
    for(let current = debutMois; current.isBefore(finMois) || current.isSame(finMois, 'day'); current = current.add(1, 'day')){
      const dateEvents = events.filter(({dateDebut, dateFin}) => (
        (current.isBefore(dateFin, 'day') || current.isSame(dateFin, 'day'))
        && (current.isAfter(dateDebut, 'day') || current.isSame(dateDebut, 'day'))
      ))
      if(dateEvents.length > 0){
        dates[current.format('YYYY-MM-DD')] = dateEvents
      }
    }
    return dates;
  }, [debutMois, events, finMois])
  if(Object.keys(eventsByDates).length > 0){
    return (
      <div style={{overflow:'scroll', flex: 1}} data-testid="SC_MAIN_CONTENT">
        {Object.entries(eventsByDates).map(([currentDate, currentEvents]) => (
          <>
            <div style={{fontSize: 12, marginTop: 15, marginLeft: 10}}>{dayjs(currentDate).format('dddd D MMMM YYYY').toUpperCase()}</div>
            {currentEvents.map((e, index) => (
              <RenderItemAgenda
                key={`${currentDate}-${e.identifiant}`}
                item={{
                  ...e,
                  identifiant: e.identifiant || 0,
                  code: e.natureAbsence?.code || '',
                  libelle: e.natureAbsence?.libelle || '',
                  icon: IconMapper[e.natureAbsence?.type || 1],
                  date: dayjs(currentDate),
                  heureDebut: dayjs(e.dateDebut).hour(Math.floor(e.heureDebut)).minute(Math.round((e.heureDebut%1)*100)).format('HH:mm'),
                  heureFin: dayjs(e.dateFin).hour(Math.floor(Math.floor(e.heureFin) || 23)).minute(e.heureFin ? Math.round((e.heureFin%1)*100) : 59).format('HH:mm'),
                  index,
                }}
                onEventPress={onSelectEvent}
              />
            ))}
          </>
        ))}
      </div>
    )
  } else {
    return (
      <View style={CalendrierDetailStyle.emptyContainer}>
        <MaterialCommunityIcons name="calendar-blank" size={80} color="#d1d5db" />
        <Text style={CalendrierDetailStyle.emptyTitle}>Aucun événement</Text>
        <Text style={CalendrierDetailStyle.emptySubtitle}>
          Pas d'événement programmé pour cette période
        </Text>
      </View>
    )
  }
}

AgendaWeb.navigate = (date: Date, action: NavigateAction, { localizer }: { localizer: DateLocalizer }) => {
  switch (action) {
    case Navigate.PREVIOUS:
      return localizer.add(date, -1, 'month')

    case Navigate.NEXT:
      return localizer.add(date, 1, 'month')

    default:
      return date
  }
}

AgendaWeb.title = (date: Date) => {
  return `${dayjs(date).format('MMMM YYYY')}`
}

export default AgendaWeb;